import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const BlogPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Blog | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Blog overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Blog</h1>
        <p>Welcome to the blog page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default BlogPage
